/**
 * Currency symbol position - runtime pass.
 *
 * The theme's own sections are handled at render time by
 * snippets/currency-symbol-position.liquid. This covers prices the theme does not
 * render itself and therefore cannot reach in Liquid:
 *   - page-builder sections (GemPages), whose generated files are rewritten
 *     whenever a merchant republishes a page
 *   - apps that inject client side (Frequently Bought Together, Loloyal loyalty)
 *
 * It rewrites at the token level: a currency symbol sitting directly against a
 * number is swapped with it, and nothing else is touched. That makes it safe on
 * running text - "Spendi altri EUR800 per sbloccare Bronze" becomes
 * "Spendi altri 800EUR per sbloccare Bronze" - while leaving prices that are
 * already in the right order, plain numbers, minus signs and brackets alone.
 *
 * Reads window.themeCurrencySymbolPosition = { position, space } from theme settings.
 */
(function () {
  var cfg = window.themeCurrencySymbolPosition || {};
  var mode = cfg.position;
  if (mode !== 'before' && mode !== 'after') return;
  var separator = cfg.space === false ? '' : ' ';

  // Real currency symbols only. Deliberately not a generic punctuation class:
  // "-2 Batterien" and "(189.99" must never be treated as symbol + number.
  var SYMBOLS = '€$£¥₹₽₩¢₺₪₦₴฿₫₱₡₲₵₸₼';
  var HAS_SYMBOL = new RegExp('[' + SYMBOLS + ']');
  var NUMBER = '\\d[\\d.,\\u00a0\\u202f ]*\\d|\\d';
  var SYMBOL_FIRST = new RegExp('([' + SYMBOLS + '])[\\u00a0 ]?(' + NUMBER + ')', 'g');
  var NUMBER_FIRST = new RegExp('(' + NUMBER + ')[\\u00a0 ]?([' + SYMBOLS + '])', 'g');

  function convert(text) {
    if (mode === 'after') {
      return text.replace(SYMBOL_FIRST, function (_m, symbol, number) {
        return number + separator + symbol;
      });
    }
    return text.replace(NUMBER_FIRST, function (_m, number, symbol) {
      return symbol + number;
    });
  }

  // Elements whose text is markup, code or form state rather than display copy.
  var SKIP = {
    SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, INPUT: 1,
    SELECT: 1, OPTION: 1, OPTGROUP: 1, CODE: 1, PRE: 1, TITLE: 1
  };

  function scan(root) {
    if (!root) return;
    if (root.nodeType === 3) { rewrite(root); return; }
    if (root.nodeType !== 1 && root.nodeType !== 9 && root.nodeType !== 11) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parent = node.parentNode;
        if (!parent || SKIP[parent.nodeName]) return NodeFilter.FILTER_REJECT;
        if (parent.isContentEditable) return NodeFilter.FILTER_REJECT;
        // cheap pre-filter: only text carrying a currency symbol can change
        return HAS_SYMBOL.test(node.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });

    var nodes = [], node;
    while ((node = walker.nextNode())) nodes.push(node);
    for (var i = 0; i < nodes.length; i++) rewrite(nodes[i]);
  }

  function rewrite(node) {
    var parent = node.parentNode;
    if (!parent || SKIP[parent.nodeName] || parent.isContentEditable) return;
    var value = node.nodeValue;
    if (!HAS_SYMBOL.test(value)) return;
    var next = convert(value);
    if (next !== value) node.nodeValue = next;
  }

  var pending = null;
  function schedule(roots) {
    if (!pending) pending = [];
    pending.push.apply(pending, roots);
    if (pending.scheduled) return;
    pending.scheduled = true;
    var run = function () {
      var batch = pending; pending = null;
      for (var i = 0; i < batch.length; i++) scan(batch[i]);
    };
    if (window.requestAnimationFrame) window.requestAnimationFrame(run);
    else window.setTimeout(run, 0);
  }

  function start() {
    scan(document.body);
    if (!window.MutationObserver || !document.body) return;
    // Apps and page-builder blocks render and re-render after load. Rewriting is
    // idempotent, so an observer pass over our own change is a no-op and settles.
    new MutationObserver(function (records) {
      var roots = [];
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        if (r.type === 'characterData') roots.push(r.target);
        else for (var j = 0; j < r.addedNodes.length; j++) roots.push(r.addedNodes[j]);
      }
      if (roots.length) schedule(roots);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
